import { QueryOptions } from '@shared/fetch-utils';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { buildUrl } from '@shared/utils';
import { PriceListItemDTO } from '@retail/purchase-agreements/types';
import { useMPEFetch, useMutateMPEFetch } from '@retail/app/hooks';
import { PaginationResultDTO } from '@shared/fetch-utils';
import { mpeApi } from '@retail/mgpris/config';

export interface SearchParamsPriceLists {
  assortmentId: number;
  agreementIds: number[];
  groupNumbers?: string[];
  query?: string;
  current?: boolean;
  active: boolean;
  page?: number;
  size?: number;
}

export function useFetchAgreementPricesComparison(
  {
    assortmentId,
    agreementIds,
    groupNumbers,
    current,
    active,
    query,
    page,
    size,
  }: SearchParamsPriceLists,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<PaginationResultDTO<PriceListItemDTO[]>>({
    method: 'GET',
    queryKey: [
      'agreement-items-comparison',
      agreementIds,
      groupNumbers,
      current,
      active,
      page,
      size,
      query,
    ],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.assortments.assortment.agreementPricesComparison.getFullLinkPath({
        assortmentId,
      }),
      searchParams: {
        page,
        size,
        'agreement-ids': agreementIds,
        groupNumbers,
        active,
        current,
        query: query !== '' ? query : undefined,
      },
    }),
    ...queryOptions,
  });
}

export function useMutateFetchAgreementPrices() {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<PaginationResultDTO<PriceListItemDTO[]>, void, SearchParamsPriceLists>({
    method: 'GET',
    token,
    url: (searchParams) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.assortments.assortment.agreementPricesComparison.getFullLinkPath({
          assortmentId: searchParams.assortmentId,
        }),
        searchParams: {
          ...searchParams,
          'agreement-ids': searchParams.agreementIds,
        },
      }),
  });
}
